import {  Routes, Route, useLocation } from 'react-router-dom';
import React, {useEffect} from 'react';
import PrivacyPolicy from './pages/privacy-policy/PrivacyPolicy';
import TermsOfUse from './pages/terms-of-use/TermsOfUse';
import Home from './Home';
import SubscriptionPolicy from './pages/subscription/Subscription';
import ContactUs from './pages/contanct-us/ContactUs';
import GooglePlayWaitList from './pages/google-play-wait-list/GooglePlayWaitList';

import ReactGA from "react-ga4";

const usePageTracking=()=> {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);
}
const App = () => {
  usePageTracking();
  return (
    <div className="App">
      <Routes>
        <Route path='/' element = {<Home/>}/>
        <Route path='/subscription-policy' element = {<SubscriptionPolicy/>}/>
        <Route path='/android' element = {<GooglePlayWaitList/>}/>
        <Route path='/contact-us' element = {<ContactUs/>}/>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
      </Routes>
    
    </div>
  );
}

export default App;
